// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-checkr{max-width:480px}.start-checkr__description{font-size:14px;line-height:18px;color:#3b3a39;margin-bottom:20px}`, "",{"version":3,"sources":["webpack://./src/modals/CheckrStart/style.scss","webpack://./src/style/variables.scss"],"names":[],"mappings":"AACA,cACE,eAAA,CAEA,2BACE,cAAA,CACA,gBAAA,CACA,aCuDU,CDtDV,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
